import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';
import { PasswordInput } from '../components/PasswordInput';
import './Login.css';

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, user } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Se já estiver autenticado e for admin ou super_admin, redirecionar para o painel
    if (isAuthenticated && (user?.role === 'admin' || user?.role === 'super_admin')) {
      navigate('/admin', { replace: true });
      return;
    }
    // Se estiver autenticado e for clínica, redirecionar para home
    if (isAuthenticated && user?.role === 'clinica') {
      navigate('/', { replace: true });
      return;
    }
    // Se estiver autenticado mas não for admin/super_admin nem clínica, redirecionar para home
    if (isAuthenticated && user?.role !== 'admin' && user?.role !== 'super_admin' && user?.role !== 'clinica') {
      navigate('/', { replace: true });
      return;
    }
  }, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await authService.loginWithCpf(email, password);
      
      // Verificar se o usuário é admin, super_admin ou clínica
      if (result.user.role !== 'admin' && result.user.role !== 'super_admin' && result.user.role !== 'clinica') {
        setError('Acesso negado. Apenas administradores e clínicas podem acessar esta área.');
        return;
      }
      
      login(result.access_token, result.user);
      
      // Redirecionar baseado no role
      if (result.user.role === 'admin' || result.user.role === 'super_admin') {
        navigate('/admin', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    } catch (error: any) {
      console.error('Erro ao fazer login:', error);
      const message = error.response?.data?.error
        || error.userMessage
        || 'Erro ao fazer login. Verifique o email e a senha. Super admin padrão: admin@causaanimal.br / Alterar@123';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Área Administrativa</h1>
        <p>Login de Administrador ou Clínica</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              disabled={loading}
              className="form-control"
              autoComplete="email"
            />
            <small className="form-hint">Super admin padrão: admin@causaanimal.br / Alterar@123 (altere após o primeiro login)</small>
          </div>
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <PasswordInput
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Digite sua senha"
              required
              disabled={loading}
            />
          </div>
          <button type="submit" className="btn btn-primary btn-login" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
          <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
            <Link to="/admin/forgot-password">Esqueci minha senha</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
